import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Form } from "react-form";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import Table from "@material-ui/core/Table";
import Toolbar from "@material-ui/core/Toolbar";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import { withStyles } from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AppContainer from "../common/AppContainer";
import TextField from "../common/TextField";
import EnhancedTableHead from "../common/EnhancedTableHead";
import CustomTableCell from "../common/TableCell";
import HelpLabel from "../common/HelpLabel";
import Select from "../common/Select";
import ReactSelect from "../common/ReactSelect";
import FileInput from "../common/FileInput";
import { createSelector } from "../common/orm";
import Snackbar from "../common/Snackbar";
import WarningDialog from "../common/WarningDialog";
import { LetterTemplate } from "../page/models";
import { authLogout } from "../auth/actions";


const allTemplates = createSelector((schema) => {
    return schema.LetterTemplate.all().orderBy("name").toRefArray();
});
const getSections = createSelector((schema) => {
    return schema.Section.orderBy(["page", "order"]).toModelArray();
});
const getAllForms = createSelector((schema) => {
    return schema.Form.all().orderBy("name").toRefArray();
});


const styles = (theme) => ({
    centerAlign: {
        textAlign: "center",
    },
    minWidth: {
        minWidth: 400,
    },
    deleteWidth: {
        minWidth: 34,
        width: 34,
        margin: "0 8px 0 0",
    },
    flex: {
        flex: 1,
    },
    linkColor: {
        color: "#2b6dad",
        textDecoration: "none",
        "&:hover": {
            backgroundColor: "#F9EBC8",
        },
    },
    root: {
        flexBasis: "100%",
        maxWidth: "100%",
    },
});

const columnData = [
    { id: "actions", numeric: false, label: "", allowSort: false },
    { id: "name", numeric: false, label: "Name", allowSort: true },
    { id: "section", numeric: false, label: "Page/Section", allowSort: true },
    { id: "form_names", numeric: false, label: "Applicable Forms", allowSort: false },
    { id: "template", numeric: false, label: "Template", allowSort: false },
];

class LetterTemplates extends Component {
    state = {
        layerDialogOpen: false,
        snackbarOpen: false,
        activeTemplate: {},
        deleteDialogOpen: false,
        selectedSection: null,
        order: "asc",
        orderBy: "name",
        isSuccess: false,
        showAllWarning: false,
    };

    errorValidator = (values) => {
        const { templates } = this.props;
        const isRequired = (val) => {
            return !val ? "Required" : null;
        };
        var valObj = {
            name: isRequired(values.name),
            section: isRequired(values.section),
            template: isRequired(values.template),
            form_names: isRequired(values.form_names),
        };
        templates.filter(ttt => ttt.id !== values.id).forEach((t) => {
            if (values.name === t.name) valObj["name"] = "Templates must have a unique name";
        });
        return valObj;
    };

    getDownloadFilename = (name) => {
        const d = new Date();
        return `${name} ${d.getMonth() + 1}-${d.getDate()}-${String(d.getFullYear()).slice(-2)}.docx`;
    };

    downloadTemplate = async (id, name) => {
        const filename = this.getDownloadFilename(name);
        try {
            const response = await fetch("/templates/download/" + id + "?filename=" + encodeURIComponent(filename));
            const blob = await response.blob();
            const blobUrl = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = blobUrl;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(blobUrl);
        } catch (e) {
            console.error("Download failed:", e);
        }
    };

    updateLayer = (values) => {
        const { ormLetterTemplateCreate, ormLetterTemplateThenUpdate, authState, authLogout, history } = this.props;
        if (typeof values.form_names === "string" && values.form_names.split(",").includes("All")) {
            values = { ...values, form_names: "All" };
        }

        if (values.id) {
            ormLetterTemplateThenUpdate({
                id: values.id,
                ...values,
            }, (e) => {
                if (e.status === 200) {
                    this.setState({ snackbarOpen: true, isSuccess: true, operationType: "save" });
                } else if (e.status === 401 || e.status === 403) {
                    authLogout(authState, history);
                }
                this.setState({ layerDialogOpen: false });

            })
        } else {
            return ormLetterTemplateCreate({
                city_id: authState.user.city_id,
                ...values,
            }).then((e) => {
                let obj = {};
                try {
                    obj = JSON.parse(e.message);
                } catch (error) {
                    // console.error("Error parsing JSON:", error);
                }

                if (e?.id) {
                    this.setState({ snackbarOpen: true, isSuccess: true, operationType: "save" });
                } else if (obj?.detail == 'Authentication credentials were not provided.') {
                    authLogout(authState, history);
                }
                this.setState({ layerDialogOpen: false });
            });
        }
        // this.setState({ layerDialogOpen: false });
    };

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = "desc";

        if (this.state.orderBy === property && this.state.order === "desc") {
            order = "asc";
        }

        if (orderBy === "section") {
            const { sections } = this.props;
            const getSectionName = (t) => {
                const found = sections.find(s => s.id === t.section);
                return found ? found.name.toUpperCase() : "";
            };
            order === "desc"
                ? this.props.templates.sort((a, b) => (getSectionName(b) < getSectionName(a) ? -1 : 1))
                : this.props.templates.sort((a, b) => (getSectionName(a) < getSectionName(b) ? -1 : 1));
        } else {
            order === "desc"
                ? this.props.templates.sort((a, b) => (b[orderBy].toUpperCase() < a[orderBy].toUpperCase() ? -1 : 1))
                : this.props.templates.sort((a, b) => (a[orderBy].toUpperCase() < b[orderBy].toUpperCase() ? -1 : 1));
        }


        this.setState({ order, orderBy });
    };

    MAKE_OPTIONS_CUST = (table) => {
        return table.map((row) => ({
            label: row.name + " (" + row.page.name + ")",
            value: row.id,
        }));
    };

    switchSection = (s) => {
        this.setState({ selectedSection: s }, () => {
            const { forms } = this.props;
            const sectionFormNames = [...new Set(
                forms.filter(f => s && f.section === s).map(f => f.name)
            )];
            const currentValue = this.dialogFormApi && this.dialogFormApi.values && this.dialogFormApi.values.form_names;
            if (sectionFormNames.length === 1 && this.dialogFormApi && !currentValue) {
                this.dialogFormApi.setValue('form_names', sectionFormNames[0]);
                this.prevFormNames = sectionFormNames[0];
            }
        });
    };

    handleFormNamesChange = (newCsv) => {
        this.prevFormNames = newCsv || "";
        const values = (newCsv || "").split(",").filter(Boolean);
        this.setState({ showAllWarning: values.includes("All") && values.length > 1 });
    };

    render() {
        const { classes, templates, ormLetterTemplateDelete, sections, forms, authState, authLogout } = this.props;
        const { layerDialogOpen, snackbarOpen, activeTemplate, deleteDialogOpen, order, orderBy, selectedSection, isSuccess, showAllWarning } = this.state;
        const selectableSections = sections.filter(s => s.name !== "Contacts");
        const sectionFormNames = [...new Set(
            forms.filter(f => selectedSection && f.section === selectedSection).map(f => f.name)
        )];
        const formNameOptions = [
            ...(sectionFormNames.length !== 1 ? [{ label: "All", value: "All" }] : []),
            ...sectionFormNames.map((name) => ({ label: name, value: name })),
        ];

        return (
            <AppContainer authenticated>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={10} classes={{ root: classes.root }}>
                        <Typography variant="h6" gutterBottom>
                            Letter & Report Templates
                        </Typography>
                        <Typography gutterBottom>
                            On this page you may upload custom reports or letters that contain placeholders which are populated with data from
                            MS4Front. When setting up a new template a list of valid placeholders will be available to download. Insert these
                            placeholder values into your custom word document. Once uploaded the template will be available to download for each
                            record associated with the selected section.
                        </Typography>
                        <Button
                            onClick={() => { this.prevFormNames = ""; this.setState({ layerDialogOpen: true, activeTemplate: {}, selectedSection: null, showAllWarning: false }); }}
                            fullWidth
                            variant="contained"
                            color="primary">
                            <AddCircleOutlineIcon />
                            &nbsp;&nbsp;&nbsp;Add New Template
                        </Button>
                    </Grid>
                    <Grid item xs={12} md={10} classes={{ root: classes.root }}>
                        <Table className={classes.minWidth}>
                            <EnhancedTableHead columnData={columnData} order={order} orderBy={orderBy} onRequestSort={this.handleRequestSort} />
                            <TableBody>
                                {templates.map((l) => {
                                    var found_section = sections.find(sss => sss.id === l.section);
                                    if (found_section) {
                                        return (
                                            <TableRow key={l.id} hover>
                                                <CustomTableCell>
                                                    <Tooltip title="Edit">
                                                        <Button
                                                            onClick={() => {
                                                                const raw = l.form_names || "";
                                                                const normalized = raw.split(",").includes("All") ? "All" : raw;
                                                                this.prevFormNames = normalized;
                                                                this.setState({
                                                                    activeTemplate: { ...l, form_names: normalized },
                                                                    layerDialogOpen: true,
                                                                    selectedSection: l.section,
                                                                    showAllWarning: false,
                                                                });
                                                            }}
                                                            className={classes.deleteWidth}>
                                                            <EditIcon color="primary" />
                                                        </Button>
                                                    </Tooltip>
                                                    <Tooltip title="Delete">
                                                        <Button
                                                            onClick={() => this.setState({ deleteDialogOpen: true, activeTemplate: l })}
                                                            className={classes.deleteWidth}>
                                                            <DeleteIcon />
                                                        </Button>
                                                    </Tooltip>
                                                </CustomTableCell>
                                                <CustomTableCell>
                                                    {l.name}
                                                </CustomTableCell>
                                                <CustomTableCell>
                                                    {found_section.page.name}: ({found_section.name})
                                                </CustomTableCell>
                                                <CustomTableCell>
                                                    {l.form_names || "—"}
                                                </CustomTableCell>
                                                <CustomTableCell>
                                                    <a className={classes.linkColor} href="#" onClick={(e) => { e.preventDefault(); this.downloadTemplate(l.id, l.name); }}>
                                                        Open Template
                                                    </a>
                                                </CustomTableCell>
                                            </TableRow>
                                        );
                                    } else return null

                                })}
                                {templates.length < 1 && (
                                    <TableRow>
                                        <CustomTableCell colSpan={5} className={classes.centerAlign}>
                                            No Templates Defined
                                        </CustomTableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} md={10} lg={8}>
                        <Typography variant="h6">Download Placeholder Template</Typography>
                        <Form dontValidateOnMount={true} validateOnSubmit={true}>
                            {(formApi) => (
                                <form onSubmit={formApi.submitForm}>
                                    <Select
                                        field="section"
                                        eventHandle={this.switchSection}
                                        options={this.MAKE_OPTIONS_CUST(selectableSections)}
                                        label="Select Section..."
                                        style={{ width: 300 }}
                                    />
                                    {selectedSection && (
                                        <Button
                                            style={{ display: "block" }}
                                            onClick={() => window.open("/reports/placeholders/" + authState.user.city_id + "/" + selectedSection)}>
                                            Download Template Placeholder for Section
                                        </Button>
                                    )}
                                </form>
                            )}
                        </Form>
                    </Grid>
                </Grid>
                <Dialog open={layerDialogOpen} classes={{ paper: classes.minWidth }}>
                    <Toolbar style={{ backgroundColor: "#d3d3d3" }}>
                        <Typography variant="h5" className={classes.flex}>
                            {Object.keys(activeTemplate).length > 0 ? "Edit" : "Add New"} Template
                        </Typography>
                        <IconButton onClick={() => this.setState({ layerDialogOpen: false })}>
                            <Close />
                        </IconButton>
                    </Toolbar>
                    <DialogContent>
                        <DialogContentText>
                            <Form
                                dontValidateOnMount={true}
                                validateOnSubmit={true}
                                validateError={this.errorValidator}
                                defaultValues={{
                                    ...activeTemplate,
                                    form_names: activeTemplate.id && !activeTemplate.form_names ? "All" : activeTemplate.form_names,
                                }}
                                onSubmit={(values) => this.updateLayer(values)}
                                onSubmitFailure={(err) => {
                                    console.log("Form Errors:", err);
                                }}
                            >
                                {(formApi) => {
                                    this.dialogFormApi = formApi;
                                    return <form onSubmit={formApi.submitForm}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <TextField field="name" label="Template Name" fullWidth />
                                            </Grid>
                                            <Grid
                                                item
                                                xs={12}
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    gap: 16
                                                }}
                                            >
                                                <Select
                                                    field="section"
                                                    eventHandle={this.switchSection}
                                                    options={this.MAKE_OPTIONS_CUST(selectableSections)}
                                                    label="Section"
                                                    fullWidth
                                                />

                                                <ReactSelect
                                                    field="form_names"
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Applicable Forms"
                                                            helpText="Select which form types this template should appear for in the Reports menu. Choose 'All' to show it on every form in this section, or select one or more specific form names."
                                                        />
                                                    }
                                                    isMulti
                                                    required
                                                    options={formNameOptions}
                                                    menuPortalTarget={document.body}
                                                    eventHandle={this.handleFormNamesChange}
                                                    fullWidth
                                                />
                                                {showAllWarning && (
                                                    <Typography variant="caption" style={{ color: "#f57c00" }}>
                                                        "All" is selected. Other selections will be ignored on save. Remove "All" to target specific forms only.
                                                    </Typography>
                                                )}

                                                {selectedSection && (
                                                    <Button
                                                        onClick={() =>
                                                            window.open("/reports/placeholders/" + authState.user.city_id + "/" + selectedSection)
                                                        }>
                                                        Download Valid Template Placeholders for Section
                                                    </Button>
                                                )}
                                            </Grid>

                                            <Grid item xs={12}>
                                                <FileInput
                                                    customaccept=".docx"
                                                    field="template"
                                                    id="template"
                                                    fullWidth
                                                    downloadUrl={activeTemplate.id ? "/templates/download/" + activeTemplate.id + "?filename=" + encodeURIComponent(this.getDownloadFilename(activeTemplate.name)) : undefined}
                                                />
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            field="signature_height"
                                                            unitsVisual="inches"
                                                            useNumberFormat
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Signature Height (optional)"
                                                                    helpText="The height of how signatures appear on this report in inches. The default is 1 inch."
                                                                />
                                                            }
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                    <Grid item xs={6}>
                                                        <TextField
                                                            field="attachment_height"
                                                            unitsVisual="inches"
                                                            useNumberFormat
                                                            label={
                                                                <HelpLabel
                                                                    inputLabel="Attachment Height (optional)"
                                                                    helpText="The height of how attachments appear on this report in inches. The default is 3 inches."
                                                                />
                                                            }
                                                            fullWidth
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <TextField
                                                    field="export_name"
                                                    label={
                                                        <HelpLabel
                                                            inputLabel="Export File Name (optional)"
                                                            helpText="When generating files from the system you can define a custom name to overwrite the default name the file is named as. Use the same template parameters as within the report. Ex: {{field_xxx}}"
                                                        />
                                                    }
                                                    fullWidth
                                                />
                                            </Grid>
                                            <Grid item xs={12} className={classes.centerAlign}>
                                                <Button type="submit" variant="contained" color="primary">
                                                    Save
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </form>;
                                }}
                            </Form>
                        </DialogContentText>
                    </DialogContent>
                </Dialog>
                <Snackbar
                    snackbarOpen={snackbarOpen}
                    handleSnackbarClose={() => this.setState({ snackbarOpen: false })}
                    isSuccess={isSuccess}
                    operationType="template"
                />
                <WarningDialog
                    confirmAction={() => {
                        ormLetterTemplateDelete(activeTemplate.id);
                        this.setState({ deleteDialogOpen: false });
                    }}
                    cancelAction={() => this.setState({ deleteDialogOpen: false })}
                    open={deleteDialogOpen}
                    title="Delete Template"
                    text={"Are you sure you wish to permanently delete " + activeTemplate.name + "?"}
                />
            </AppContainer>
        );
    }
}
LetterTemplates.displayName = "LetterTemplates";

LetterTemplates = connect(
    (state) => ({
        templates: allTemplates(state),
        sections: getSections(state),
        forms: getAllForms(state),
        authState: state.auth,
    }),
    {
        ...LetterTemplate.actions,
        authLogout,
    }
)(LetterTemplates);

export default withStyles(styles)(withRouter(LetterTemplates));
